import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { ErrorService } from './error.service';
import { Doctor, HcProviderLink, HealthcareProvider, HealthcareProviderFunc } from './webapiclient.service';

@Injectable({
  providedIn: 'root'
})
export class HcProviderService {

  constructor(
    private healthcareProviderFunc: HealthcareProviderFunc,
    private errorService: ErrorService

  ) { }
  async get(id: string) {
    let model: HealthcareProvider = {} as HealthcareProvider;
    return new Promise((resolve, reject) => {
        this.healthcareProviderFunc.get(id).pipe(first()).subscribe({
          next: (v) => model = v,
          error: (e) => reject(e.message),
          complete: () => resolve(model)
        })
    });
  }

  async getAll() {
    let model: HealthcareProvider[] = {} as HealthcareProvider[];
    return new Promise((resolve, reject) => {
        this.healthcareProviderFunc.getAll().pipe(first()).subscribe({
          next: (v) => model = v,
          error: (e) => reject(e.message),
          complete: () => resolve(model)
        })
    });
  }

  //hc provider links
  async getLinks(id: string) {
    let model: HcProviderLink[] = {} as HcProviderLink[];
    return new Promise((resolve, reject) => {
        this.healthcareProviderFunc.getLinks(id).pipe(first()).subscribe({
          next: (v) => model = v,
          error: (e) => reject(e.message),
          complete: () => resolve(model)
        })
    });
  }

   async insertLink(userId: string,values: string) {
    let result: any;
    return new Promise((resolve, reject) => {
        this.healthcareProviderFunc.insertLink(userId,values).pipe(first()).subscribe({
          next: (v) => result = v,
          error: (e) => reject(e),
          complete: () => {
            if (result.body === "OK") {
              resolve("OK");
            } else {
              reject(result.body);
            }
          }
        })
    });
  }
  
  async deleteLink(userId: string, providerId: string) {
    let result: any;
    return new Promise((resolve, reject) => {
        this.healthcareProviderFunc.deleteLink(userId,providerId).pipe(first()).subscribe({
          next: (v) => result = v,
          error: (e) => reject(e),
          complete: () => {
            if (result.body === "OK") {
              resolve("OK");
            } else {
              reject(result.body);
            }
          }
        })
    });
  }

  async getDoctorsByProvider(providerId: string) {
    let model: Doctor[] = {} as Doctor[];
    return new Promise((resolve, reject) => {
        this.healthcareProviderFunc.getDoctorsByProvider(providerId).pipe(first()).subscribe({
          next: (v) => model = v,
          error: (e) => reject(e.message),
          complete: () => resolve(model)
        })
    });
  }

}
